import { gql } from '@apollo/client';

export const DELETE_PAINTING = gql`
  mutation DeletePainting($id: Int!) {
    success: deletePainting(id: $id)
  }
`;
